// VUE CONSTANTS, SETTINGS, & HELPERS


/**
 * This is the ID attribute of the <div> that Vue will mount to.
 *
 * @type {string}
 */
export const FUNNEL_VUE_INSTANCE_ID = '#funnel';

/**
 * Config settings for the 'vueMny' 3rd-party Vue component.
 *
 * @return {{currencyDisplay: string, currency: string, locale: string}}
 */
export const MNY_VUE_COMPONENT_CONFIG = {
   locale: window.mymy.request.currentSite.language,
   currency: window.mymy.request.currency,
   currencyDisplay: 'symbol',
};

/**
 * Config settings for the 'VueScrollTo' 3rd-party Vue component.
 *
 * @return {{offset: number}}
 */
export const SCROLL_VUE_COMPONENT_CONFIG = {
   offset: -110, // the height of the floating header at the top of the page
};